import { render } from "./InstructorBlogsList.vue?vue&type=template&id=b11b3ddc"
import script from "./InstructorBlogsList.vue?vue&type=script&lang=js"
export * from "./InstructorBlogsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__